import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MainImage from '~/components/atoms/Editorial/MainImage.vue';
import PlusDisplayLayer from '~/components/atoms/Editorial/PlusDisplayLayer.vue';
import ImageLegend from '~/components/atoms/Editorial/ImageLegend.vue';
export default {
  name: 'ImageLayerLegend',
  components: {
    MainImage: MainImage,
    PlusDisplayLayer: PlusDisplayLayer,
    ImageLegend: ImageLegend
  },
  props: {
    context: {
      type: String,
      required: true
    },
    reference: {
      type: String,
      required: true
    },
    layer: {
      type: Boolean,
      default: false
    },
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      default: ''
    },
    alt: {
      type: String,
      default: ''
    },
    ratio: {
      type: String,
      default: ''
    },
    legend: {
      type: Array,
      required: true
    },
    negativeText: {
      type: Boolean,
      default: true
    }
  }
};